<div class="main-layout">
    <org-layout-header></org-layout-header>
    <mol-active-order-banner/>
    <router-outlet></router-outlet>
    <org-layout-footer></org-layout-footer>
</div>